// One object per environment, picked from the hosting origin at load time.
const premium = {
  baseUrl: process.env.VUE_APP_TELKOM_PREMIUM_BASE_URL || '',
  stagingBaseUrl: process.env.VUE_APP_TELKOM_PREMIUM_STAGING_BASE_URL || '',
  mode: process.env.VUE_APP_TELKOM_PREMIUM_MODE || ''
}

export const productionConfig = {
  integrationService: `${process.env.VUE_APP_INTEGRATION_SERVICE}`,
  telkomPremiumBaseUrl: premium.baseUrl,
  telkomPremiumStagingBaseUrl: premium.stagingBaseUrl,
  telkomPremiumMode: premium.mode || 'live',
  nodeEnv: 'Prod'
}

export const developmentConfig = {
  integrationService: `${process.env.VUE_APP_DEVELOPMENT_INTEGRATION_SERVICE}`,
  telkomPremiumBaseUrl: premium.baseUrl,
  telkomPremiumStagingBaseUrl: premium.stagingBaseUrl,
  telkomPremiumMode: premium.mode || 'live',
  nodeEnv: 'Dev'
}

export const localConfig = {
  integrationService: `${process.env.VUE_APP_LOCAL_INTEGRATION_SERVICE}`,
  telkomPremiumBaseUrl: premium.baseUrl,
  telkomPremiumStagingBaseUrl: premium.stagingBaseUrl,
  telkomPremiumMode: premium.mode || 'mock',
  nodeEnv: 'Local'
}

export const environmentConfig = getEnvObject(getEnvironment())

function getEnvironment() {
  const origin = window.location.origin
  if (origin.includes('localhost')) return 'local'
  if (origin.includes('staging') || origin.includes('dev')) return 'development'
  return 'production'
}

function getEnvObject(environment) {
  if (environment === 'local') return localConfig
  if (environment === 'development') return developmentConfig
  return productionConfig
}
